import React from "react";
import "./custom-button.css";

function CustomButton(props) {
  return (
    <a target={props.target} rel="noopener noreferrer" href={props.target_link}>
      <button
        type="button"
        className={`custom-btn btn-14 ${props.color} ${props.className}`}
      >
        {props.text}
      </button>
    </a>
  );
}

export default CustomButton;
